import { useLingui } from "@lingui/react/macro";
import { Text, Title } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

import { DocHeading } from "@/components/docs/DocHeading.tsx";
import { DocImage } from "@/components/docs/DocImage.tsx";
import { DocsContent } from "@/components/docs/DocsContent.tsx";
import latestSearchEn from "@/docs/images/property-search/recent-searches.en.webp";
import latestSearchSv from "@/docs/images/property-search/recent-searches.sv.webp";
import searchEn from "@/docs/images/property-search/search.en.webp";
import searchSv from "@/docs/images/property-search/search.sv.webp";

export const Route = createFileRoute("/docs/property-search/select-properties")(
  {
    component: RouteComponent,
  },
);

function RouteComponent() {
  const { t } = useLingui();

  return (
    <DocsContent>
      <Title order={1} size="h2">{t`Select properties`}</Title>
      <Text>
        {t`This is the first step of the property search process. You can search for properties by property designations or by the addresses. In the future,
        you will also be able to search by selecting properties from the map or load from file. You can select as many properties as you
        need. All your selected properties are listed under the "Selected properties" section.`}
      </Text>

      <DocHeading
        order={2}
        size="h3"
      >{t`Search by property designation or address`}</DocHeading>
      <Text>
        {t`Use the search field under the title 'Select properties' to search for properties either by the property designation or by the address.
        Your latest searches as property designations will be displayed in the drop-down list.`}
      </Text>
      <DocImage
        src={{ sv: latestSearchSv, en: latestSearchEn }}
        alt={t`Recent searches`}
        height={300}
      />
      <Text>
        {t`A property designation is normally the most precise way to search for a property. It consists of a municipality name, district name, block number,
        and unit number. In the property designation "Stockholm Gården 11:1", Stockholm is the municipality name, Gården is the district name, 11 is the
        block number, and 1 is the unit number. If you search by address, you can either search by the full address or by parts of the address.`}
        {t`The search result will display ten of the properties matching your search criteria divided into Register Units and Addresses. Click on the
        specific property that your search was intended for. Repeat this search process for all the properties you want to select.`}
      </Text>

      <DocImage
        src={{ sv: searchSv, en: searchEn }}
        alt={t`Search field`}
        height={500}
      />

      <DocHeading order={2} size="h3">{t`Search in the map`}</DocHeading>
      <Text>{t`We are working on enabling search directly within an integrated map on the REALity website.`}</Text>

      <DocHeading order={2} size="h3">{t`Load from file`}</DocHeading>
      <Text>{t`We are working on enabling upploading properties within a polygon from a GeoJSON or Shapefile.`}</Text>
    </DocsContent>
  );
}
